<template>

    <!-- loading spinner -->
    <div v-if="loading" id="blockchain-data-loading">
        <div class="lds-facebook"><div></div><div></div><div></div></div>
        <!-- <div>{{ loadingText }}</div> -->
    </div>

    <div v-else>
        <!-- Top buttons -->
        <div style="width: 100%; float:left;">
            <div style="float: right">

                <!-- new (load template) -->
                <button type="button" class="btn btn-primary btn-sm" @click="selectTemplateModalOpened()" v-b-modal="'select-template-modal'">
                    <font-awesome-icon icon="fa-solid fa-file-contract" /><span style="padding-left: 10px;">Load Template</span>
                </button> 

                <!-- old (load test )-->
                <!-- <span style="margin-left: 10px;"></span> -->
                <button type="button" class="btn btn-primary btn-sm" @click="loadTestContractDesign()" style="display: none;">
                    <font-awesome-icon icon="fa-solid fa-file-contract" /><span style="padding-left: 10px;">Load Test</span>
                </button> 

                <!-- create new -->
                <!-- <button type="button" class="btn btn-primary btn-sm" style="margin-left: 10px" @click="createNewDesign()" v-b-modal="'new-contract-design-modal'"> -->
                <button type="button" class="btn btn-primary btn-sm" style="margin-left: 10px">               
                    <font-awesome-icon icon="fa-solid fa-plus" /><span style="padding-left: 10px;">Create New</span>
                </button>    

            </div>

            <!-- commit to blockchain button (hidden) -->
            <div style="display: none;">
                <button id="commit-to-blockchain-button" type="button" class="btn btn-warning btn-sm" v-b-modal="'commit-to-blockchain-modal'" style="float: left; display: none">
                    <font-awesome-icon icon="fa-solid fa-cloud-upload-alt" /><span style="padding-left: 10px;">Commit to Blockchain</span>
                </button>
            </div>

        </div>

        <!-- template container -->
        <div v-if="showTemplateContainer" id="template-container" style="width: 100%; float: left; padding-bottom: 80px; padding-top: 30px;">

            <!-- loading spinner -->
            <div v-if="templateLoading" id="page-data-loading" style="margin-top: 150px;">
                <div class="lds-facebook"><div></div><div></div><div></div></div>
                <!-- <div>{{ loadingText }}</div> -->
                <!-- <div>Loading...</div> -->
            </div>

            <!-- template designer -->
            <div v-else>

                <h4>Template Information</h4>
                <table class="template-info-table">
                    <tr>
                        <td><b>Name:</b></td>
                        <td>{{ template.TempData.contract.name }}</td>
                        <td class="template-info-table-right"><b>ID:</b></td>
                        <td>{{ template.ID }}</td>                        
                    </tr>
                    <tr>
                        <td><b>Author:</b></td>
                        <td>Simon McAloon</td>
                        <td class="template-info-table-right"><b>Updated:</b></td>
                        <td>Wed, 24 Jan 2024 12:15:24 PM</td>
                    </tr>      
                    <tr>
                        <td><b>Owner:</b></td>
                        <td>Vitrafy</td>
                        <td class="template-info-table-right"><b>Version:</b></td>
                        <td>3</td>
                    </tr>                                                                         
                </table>

                <br /><br />

                <div style="width: 100%; float: left; margin-bottom: 8px;">
                    <div style="float: left">
                        <h4>Template</h4>
                    </div>
                    <div style="float: right">
                        <!-- cancel -->
                        <span style="margin-left: 10px"></span>
                        <button type="button" class="btn btn-secondary btn-sm">
                            <span>Cancel</span>
                        </button> 

                        <!-- publish -->
                        <button type="button" class="btn btn-primary btn-sm" style="margin-left: 10px" disabled>
                            <span>Publish</span>
                        </button>
                    </div>
                </div>

                <div class="template-container">
                    <div>
                        <div v-for="m in template.TempData.contract.milestones" :key="m.id">

                            <!-- plus button -->
                            <div class="template-milestone-add-container">
                                <div class="template-milestone-add">
                                    <div class="template-milestone-add-plus">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" aria-label="Add Stage" class="chakra-button css-1a7fabk" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><title>Add Stage</title><path fill="none" d="M0 0h24v24H0z"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>
                                    </div>                                
                                </div>
                            </div>

                            <!-- line -->
                            <div class="template-milestone-add-line template-milestone-add-line-big"></div>

                            <!-- milestones -->
                            <div class="template-milestone">

                                <!-- milestones header -->
                                <div class="template-milestone-header">
                                    <div>
                                        <!-- images -->
                                        <img v-if="m.iconImage == 1" src="../assets/images/templateIcons/1.png"/>
                                        <img v-if="m.iconImage == 2" src="../assets/images/templateIcons/2.png"/>
                                        <img v-if="m.iconImage == 3" src="../assets/images/templateIcons/3.png"/>
                                        <img v-if="m.iconImage == 4" src="../assets/images/templateIcons/4.png"/>
                                        <img v-if="m.iconImage == 5" src="../assets/images/templateIcons/5.png"/>
                                        <img v-if="m.iconImage == 6" src="../assets/images/templateIcons/6.png"/>
                                        <img v-if="m.iconImage == 7" src="../assets/images/templateIcons/7.png"/>
                                        <img v-if="m.iconImage == 8" src="../assets/images/templateIcons/8.png"/>
                                        <img v-if="m.iconImage == 9" src="../assets/images/templateIcons/9.png"/>
                                        <img v-if="m.iconImage == 10" src="../assets/images/templateIcons/10.png"/>
                                        <img v-if="m.iconImage == 11" src="../assets/images/templateIcons/11.png"/>
                                        <img v-if="m.iconImage == 12" src="../assets/images/templateIcons/12.png"/>

                                        <img v-if="m.iconImage == 'SUCT-1'" src="../assets/images/templateIcons/testIcons/1.png"/>
                                        <img v-if="m.iconImage == 'SUCT-2'" src="../assets/images/templateIcons/testIcons/2.png"/>
                                        <img v-if="m.iconImage == 'SUCT-3'" src="../assets/images/templateIcons/testIcons/3.png"/>
                                        <img v-if="m.iconImage == 'SUCT-4'" src="../assets/images/templateIcons/testIcons/4.png"/>
                                        <img v-if="m.iconImage == 'SUCT-5'" src="../assets/images/templateIcons/testIcons/5.png"/>
                                        <img v-if="m.iconImage == 'SUCT-6'" src="../assets/images/templateIcons/testIcons/package.png"/>
                                        <img v-if="m.iconImage == 'SUCT-9'" src="../assets/images/templateIcons/testIcons/9.png"/>

                                        <img v-if="m.iconImage == 'CSLHSC-1'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-1.png"/>
                                        <img v-if="m.iconImage == 'CSLHSC-2'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-2.png"/>
                                        <img v-if="m.iconImage == 'CSLHSC-3'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-3.png"/>
                                        <img v-if="m.iconImage == 'CSLHSC-4'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-4.png"/>
                                        <img v-if="m.iconImage == 'CSLHSC-5'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-5.png"/>
                                        <img v-if="m.iconImage == 'CSLHSC-6'" src="../assets/images/templateIcons/CSLHSC/CSLHSC-6.png"/>                                    

                                        <!-- milestone name -->
                                        <span>{{ m.id }} {{ m.name }}</span>

                                        <div class="template-milestone-add template-milestone-header-actions">
                                            <div class="template-milestone-add-plus">
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-8g7uf9" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"></path></svg>
                                            </div>                                
                                        </div>
                                        <div class="template-milestone-add template-milestone-header-actions">
                                            <div class="template-milestone-add-plus">
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-8g7uf9" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m14.06 9.02.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"></path></svg>
                                            </div>                                
                                        </div>                                    

                                    </div>

                                    <!-- up arrow -->
                                    <div class="template-milestone-add-container template-milestone-add-container-up-arrow">
                                        <div class="template-milestone-add template-milestone-add-up-arrow">
                                            <div class="template-milestone-add-plus template-milestone-add-plus-up-arrow">
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-1xtau4s" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path></svg>
                                            </div>                                
                                        </div>
                                    </div>

                                </div>

                                <!-- Subprocess -->
                                <div class="template-subprocess-container">

                                    <!-- Subprocesses -->
                                    <div v-for="sp in m.subprocesses" :key="sp.id">

                                        <!-- plus button -->
                                        <div class="template-milestone-add-container">
                                            <div class="template-milestone-add">
                                                <div class="template-milestone-add-plus">
                                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" aria-label="Add Stage" class="chakra-button css-1a7fabk" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><title>Add Stage</title><path fill="none" d="M0 0h24v24H0z"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>
                                                </div>                                
                                            </div>
                                        </div>
                                        <!-- line -->
                                        <div class="template-milestone-add-line"></div>

                                        <div class="template-subprocess">

                                            <div class="template-subprocess-left-action-container"></div>

                                            <div class="template-subprocess-left-action">
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1qiwd9j" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg>
                                            </div>

                                            <div class="template-subprocess-content">
                                                {{ sp.id }} {{ sp.name }}
                                            </div>

                                            <div class="template-subprocess-right-action">
                                                <div class="template-milestone-add">
                                                    <div class="template-milestone-add-plus">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-8g7uf9" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m14.06 9.02.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"></path></svg>
                                                    </div>                                
                                                </div>
                                                <div class="template-milestone-add">
                                                    <div class="template-milestone-add-plus">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-8g7uf9" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"></path></svg>
                                                    </div>                                
                                                </div>                                                
                                            </div>
                                            
                                        </div>

                                        <!-- line -->
                                        <div class="template-milestone-add-line"></div>                                
                                    </div>

                                    <!-- plus button -->
                                    <div class="template-milestone-add-container">
                                        <div class="template-milestone-add">
                                            <div class="template-milestone-add-plus">
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" aria-label="Add Stage" class="chakra-button css-1a7fabk" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><title>Add Stage</title><path fill="none" d="M0 0h24v24H0z"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>
                                            </div>                                
                                        </div>
                                    </div>

                                </div>

                                <!-- down arrow -->
                                <div class="template-milestone-add template-milestone-add-up-arrow template-milestone-add-down-arrow">
                                    <div class="template-milestone-add-plus template-milestone-add-plus-up-arrow">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" class="chakra-button css-ezlm9v" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path></svg>
                                    </div>                                
                                </div>

                            </div>
                            
                            <!-- line -->
                            <div class="template-milestone-add-line template-milestone-add-line-big"></div>
                            
                        </div>

                        <!-- plus button -->
                        <div class="template-milestone-add-container">
                            <div class="template-milestone-add">
                                <div class="template-milestone-add-plus">
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" type="button" aria-label="Add Stage" class="chakra-button css-1a7fabk" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><title>Add Stage</title><path fill="none" d="M0 0h24v24H0z"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>
                                </div>                                
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>         

        <!-- designer container -->
        <div id="designer-container" style="width: 100%; float: left; padding-bottom: 80px; padding-top: 30px;">

            <!-- tabs -->
            <b-tabs content-class="mt-3">
                <!-- designer -->
                <b-tab title="Designer">
                    
                    <!-- design panel (design)-->
                    <div class="design-panel">
                        <!-- <h6>Designer</h6> -->
                        
                        <!-- contract design info -->
                        <table class="contrat-info-table">
                            <tr>
                                <td>
                                    <b>Name</b>
                                </td>
                                <td class="contract-data">
                                    {{ design.contractDesignName }}
                                </td>                    
                            </tr>
                            <tr>
                                <td>
                                    <b>Created </b> 
                                </td>
                                <td class="contract-data">
                                    {{ design.creationDateTime }}
                                </td>                    
                            </tr>
                            <tr>
                                <td>
                                    <b>Author</b>
                                </td>
                                <td class="contract-data">
                                    {{ design.createdBy }}
                                </td>                    
                            </tr>                                
                        </table>
                        
                        <!-- Stages --> 
                        <div class="design-stage-container" v-for="stage in design.stages" v-bind:key="stage.ID">
                            <div class="design-stage standard-stage" v-bind:class="{ 
                                'design-subprocess' : stage.stageType === 'subprocess', 
                                'initialization-stage' : stage.stageType === 'initialization', 
                                'completion-stage': stage.stageType === 'completion'}"
                                >
                                <div class="stage-menu">
                                    <div>
                                        <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret>
                                            <template #button-content>
                                                <font-awesome-icon icon="ellipsis-v" />
                                            </template>
                                            <b-dropdown-item href="#" v-b-modal="'edit-stage-modal'" @click="selectedStageForModal(stage)">Edit</b-dropdown-item>
                                            <b-dropdown-item href="#" v-b-modal="'delete-stage-modal'" @click="selectedStageForModal(stage)">Delete</b-dropdown-item>
                                        </b-dropdown>
                                    </div>

                                </div>
                                <div class="stage-badge"> {{ stage.stageType }}<br />{{ stage.stage }} </div>
                                <div style="padding-top: 20px">{{ stage.stageName }} </div>
                            </div>

                            <!-- links -->
                            <div v-if="stage.stageType != 'completion'" class="link-line" style="float: left; width: 100%; position: relative;">
                                <!-- link left -->
                                <div class="design-stage" style="padding: 0; border: 0; z-index:99">
                                    <div style="width: 50%; border-right: 2px solid; padding: 30px; background-color: white;">
                                        <div v-if="stage.subprocesses.length > 0" style="width: 100%; height: 50%; position: absolute; left: 0; bottom: -2px; background: white;"></div>
                                        <font-awesome-icon v-if="stage.subprocesses.length == 0" style="position: absolute; bottom: -6px; right: 47%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                    </div>
                                </div>
                                <!-- link right -->
                                <div v-if="stage.subprocesses.length > 0 || stage.id == design.stages[design.stages.length -1].id">
                                    <div class="design-stage design-subprocess" style="padding: 0; border: 0; z-index:99">
                                        <div style="width: 50%; border-left: 2px solid; padding: 30px; background-color: white; float: right;">
                                            <div style="width: 100%; height: 50%; position: absolute; left: 0; top: 0px; background: white;"></div>
                                            <font-awesome-icon style="position: absolute; bottom: -6px; right: 46%; font-size: 16px" icon="fa-solid fa-chevron-down" />
                                        </div>
                                    </div>
                                    <div style="border-bottom: 2px solid; position: absolute; width: 100%; top: 50%;"></div>
                                </div>
                            </div>              

                            <!-- Subprocesses -->
                            <div class="design-stage-container" v-for="subprocess in stage.subprocesses" v-bind:key="subprocess.ID">
                                <div class="design-stage" v-bind:class="{ 'design-subprocess' : subprocess.stageType === 'subprocess'}">
                                    <div class="stage-menu">
                                        <div>
                                            <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret>
                                                <template #button-content>
                                                    <font-awesome-icon icon="ellipsis-v" />
                                                </template>
                                                <b-dropdown-item href="#" v-b-modal="'edit-stage-modal'" @click="selectedStageForModal(subprocess)">Edit</b-dropdown-item>
                                                <b-dropdown-item href="#" v-b-modal="'delete-stage-modal'" @click="selectedStageForModal(subprocess)">Delete</b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                <div class="stage-badge"> {{ subprocess.stageType }}<br />{{ subprocess.stage }} </div>
                                <div style="padding-top: 20px">{{ subprocess.stageName }} </div>
                                </div>

                                <!-- links -->
                                <div class="link-line" style="float: left; width: 100%; position: relative;">
                                    <!-- link left -->
                                    <div v-if="subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" class="design-stage" style="padding: 0; border: 0; z-index:99">
                                        <div style="width: 50%; border-right: 2px solid; padding: 30px; background-color: white;">
                                            <div v-if="stage.subprocesses.length > 0" style="width: 100%; height: 50%; position: absolute; left: 0; top: 0px; background: white;"></div>
                                            <font-awesome-icon style="position: absolute; bottom: -6px; right: 47%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                        </div>
                                    </div>
                                    <!-- link right -->
                                    <div class="design-stage design-subprocess" style="padding: 0; border: 0; z-index:99">
                                        <div style="width: 50%; border-left: 2px solid; padding: 30px; background-color: white; float: right;">
                                            <div v-if="stage.id != design.stages[design.stages.length -1].id && subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" style="width: 100%; height: 50%; position: absolute; left: 0; bottom: -2px; background: white;"></div>
                                            <font-awesome-icon v-if="stage.id == design.stages[design.stages.length -1].id || subprocess.id != stage.subprocesses[stage.subprocesses.length -1].id" style="position: absolute; bottom: -6px; right: 46%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                        </div>
                                    </div>
                                    <div v-if="subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" style="border-bottom: 2px solid; position: absolute; width: 100%; top: 50%;"></div>
                                </div>                               

                            </div> 
                        </div>

                        <!-- Add Stage button-->
                        <div class="design-stage add-stage" style="padding-top: 10px !important;" v-if="!contractComplete">
                            <a href="#" @click="createStage()" v-b-modal="'new-stage-modal'" style="text-decoration: none;">
                                <font-awesome-icon icon="fa-solid fa-plus" /> Add Stage
                            </a>
                        </div>

                        <!-- Add Subprocess button-->
                        <div class="design-stage add-stage add-subprocess" style="padding-top: 10px !important;" v-if="!contractComplete && hasInitializationStage">
                            <a href="#" @click="createStage('subprocess')" v-b-modal="'new-stage-modal'" style="text-decoration: none;">
                                <font-awesome-icon icon="fa-solid fa-plus" /> Add Subprocess
                            </a>
                        </div>

                    </div>

                </b-tab>

                <!-- Code (JSON) -->
                <b-tab title="Code (JSON)">

                    <!-- design panel (code)-->
                    <div class="design-panel">
                        <!-- <h6>Code (JSON)</h6> -->
                        <pre>{{ design }}</pre>
                    </div>

                </b-tab>                                            
            </b-tabs>        

            <!-- Select Template modal -->
            <b-modal id="select-template-modal" title="Select Template" button-size="sm" @ok="selectTemplateOk">
                <div>
                    <b-form-group label="Available Templates:">
                        <b-form-select v-model="currentSelectedTemplate" :options="selectedTemplateOptions" size="sm"></b-form-select>
                    </b-form-group>                    
                </div>
            </b-modal>

            <!-- New contract design modal -->
            <b-modal id="new-contract-design-modal" title="Create New Workflow" button-size="sm" @ok="createNewContractDesign">
                <div>
                    <b-form-group label="Workflow Name:">
                        <b-form-input v-model="design.contractDesignName" size="sm"></b-form-input>
                    </b-form-group>                      
                </div>
            </b-modal>

            <!-- New stage modal -->
            <b-modal id="new-stage-modal" title="Add Stage" button-size="sm" @ok="addStage">
                <div>
                    <b-form-group label="Stage Type:">
                        <b-form-select v-model="newStage.stageType" :options="options" size="sm" :disabled="disableSelect"></b-form-select>
                    </b-form-group>
                    <b-form-group v-if="newStage.stageType == 'initialization' || newStage.stageType == 'milestone'" label="Stage Name:">
                        <!-- <b-form-input v-model="newStage.stageName" :options="stages" size="sm"></b-form-input> -->
                        <b-form-select v-model="newStage.stageName" :options="stages" size="sm"></b-form-select>
                    </b-form-group>
                    <b-form-group v-else label="Subprocess Name:">
                        <!-- <b-form-input v-model="newStage.stageName" :options="stages" size="sm"></b-form-input> -->
                        <b-form-select v-model="newStage.stageName" :options="subprocesss" size="sm"></b-form-select>
                    </b-form-group>                    
                    <b-form-group label="Authorised Entity:">
                        <b-form-input v-model="newStage.authorisedEntity" size="sm"></b-form-input>
                    </b-form-group>                    
                </div>
            </b-modal>

            <!-- Edit stage modal -->
            <b-modal id="edit-stage-modal" title="Edit Stage" button-size="sm" @ok="editStage" ok-title="Update">
                <div>
                    <b-form-group label="Stage Type:">
                        <b-form-select v-model="selectedStage.stageType" :options="options" size="sm" :disabled="disableSelect"></b-form-select>
                    </b-form-group>
                    <b-form-group label="Stage Name:">
                        <b-form-input v-model="selectedStage.stageName" size="sm"></b-form-input>
                    </b-form-group>
                </div>
            </b-modal>            

            <!-- Stage delete modal -->
            <b-modal id="delete-stage-modal" title="Delete Stage" @ok="deleteStage">
                <div>
                    Are you sure you want to delete <b>{{ selectedStage.stageName }}</b>?
                </div>
                <template #modal-footer="{ cancel, ok }">
                    <b-button size="sm" variant="secondary" @click="cancel()">
                        Cancel
                    </b-button>                    
                    <b-button size="sm" variant="danger" @click="ok()">
                        Delete
                    </b-button>
                </template>
            </b-modal>

            <!-- Commit to blockchain modal -->
            <b-modal id="commit-to-blockchain-modal" title="Commit to Blockchain" @ok="commitToBlockchain">
                <div>
                    <b-alert show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span style="padding-left: 10px;"><b>Warning Alert</b></span><br />This process is irreversible and will add an immutable record of this contract design to the blockchain (test-network)</b-alert>
                    Are you sure you want to commit <b>{{ design.contractDesignName }}</b> to the blockchain?
                </div>
                <template #modal-footer="{ cancel, ok }">
                    <b-button size="sm" variant="secondary" @click="cancel()">
                        Cancel
                    </b-button>                    
                    <b-button size="sm" variant="warning" @click="ok()">
                        Commit
                    </b-button>
                </template>
            </b-modal>

        </div>

    </div>
</template>
 
<script>
    import ART from './Templates/ART.json';
    import HSC from './Templates/HSC.json';
    import CART from './Templates/CAR-T.json';

    export default {
        name: "Designer",
        data() {
            return {
                loading: true,
                templateLoading: true,
                ARTTemplate: ART,
                HSCTemplate: HSC,
                CARTTemplate: CART,
                template: null,
                selectedTemplate: null,
                currentSelectedTemplate: null,
                selectedTemplateOptions: [
                    { value: 'CAR-T', text: 'CAR-T (Chimeric Antigen Receptor T-Cell) Therapy - Template'},
                    { value: 'ART', text: 'Human Sperm - Template' },
                    { value: 'HSC', text: 'HSC Template' },
                ],
                showTemplateContainer: false,
                newStage: {
                    stageName: "New Stage",
                    stageType: null,
                    authorisedEntity: this.$parent.userInfo.username
                },
                design: {
                    uuid: null,
                    timestamp: null,
                    contractDesignName: "Test Workflow 1",
                    creationDateTime: "",
                    createdBy: "",
                    contractCompleted: false,
                    authorisedEntity: this.$parent.userInfo.username,
                    stages: []
                },
                testDesign: {
                    "uuid": "eb019a50-5525-45e5-b33d-67a930cd25c2",
                    "timestamp": 1649819521919,
                    "contractDesignName": "Test Workflow 1",
                    "creationDateTime": "2022-04-13T03:12:01.919Z",
                    "createdBy": "smcaloon@vitrafy.com",
                    "contractCompleted": false,
                    "authorisedEntity": "smcaloon@vitrafy.com",
                    "stages": [
                        {
                        "uuid": "7bf30d8a-64fc-4c45-a082-6cf383097daf",
                        "timestamp": 1649819553687,
                        "id": 1,
                        "created": "2022-04-13T03:12:33.687Z",
                        "stage": 1,
                        "stageType": "initialization",
                        "stageName": "Workflow Created",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        },
                        {
                        "uuid": "137fc1a3-0c38-4fe2-bb9b-060788a2a858",
                        "timestamp": 1649819588695,
                        "id": 2,
                        "created": "2022-04-13T03:13:08.695Z",
                        "stage": 2,
                        "stageType": "milestone",
                        "stageName": "Doctor Patient Identification",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        },
                        {
                        "uuid": "20704028-37c5-4ce6-8ccb-556e048494d7",
                        "timestamp": 1649819610009,
                        "id": 3,
                        "created": "2022-04-13T03:13:30.009Z",
                        "stage": 3,
                        "stageType": "milestone",
                        "stageName": "Patient Collection",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        },
                        {
                        "uuid": "c03ac8e3-ed7c-4a92-a63b-8084f2b5353a",
                        "timestamp": 1649819650647,
                        "id": 4,
                        "created": "2022-04-13T03:14:10.647Z",
                        "stage": 4,
                        "stageType": "milestone",
                        "stageName": "Isolation Leukapheresis",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        },
                        {
                        "uuid": "4efa6575-4c10-41f5-b976-f78bec204580",
                        "timestamp": 1649819665887,
                        "id": 5,
                        "created": "2022-04-13T03:14:25.887Z",
                        "stage": 5,
                        "stageType": "milestone",
                        "stageName": "Controlled Cryopreservation",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        },
                        {
                        "uuid": "15fe4c0c-f902-4fd6-b61b-e04d475fc704",
                        "timestamp": 1649819680979,
                        "id": 6,
                        "created": "2022-04-13T03:14:40.979Z",
                        "stage": 6,
                        "stageType": "completion",
                        "stageName": "Close Workflow",
                        "stageCompleted": false,
                        "authorisedEntity": "smcaloon@vitrafy.com",
                        "stageActions": [],
                        "subprocesses": []
                        }
  ]
                },
                selectedStage: {},
                disableSelect: false,
                options: [
                    // { value: null, text: 'Please select an option' },
                    { value: 'initialization', text: 'Initialization Stage'},
                    { value: 'milestone', text: 'Milestone Stage' },
                    //{ value: 'subprocess', text: 'Subprocess Stage' },
                    { value: 'completion', text: 'Completion Stage' },
                ],
                stages: [
                    { value: 'Collection', text: 'Collection'},
                    { value: 'Preparation', text: 'Preparation' },
                    { value: 'Cryopreservation', text: 'Cryopreservation' },
                    { value: 'Storage', text: 'Stroage' },
                    { value: 'Thawing', text: 'Thawing' },                    
                    { value: 'Assessment', text: 'Assessment' },
                    { value: 'Application', text: 'Application' }
                ],   
                subprocesss: [
                    { value: 'Donor ID', text: 'Donor ID'},
                    { value: 'Sample ID', text: 'Sample ID'},
                    { value: 'Sample Testing', text: 'Sample Testing'},
                    { value: 'Guardion Device', text: 'Guardion Device' },
                    { value: 'Thawing Device', text: 'Thawing Device' },
                    { value: 'Storage Information', text: 'Storage Information' },                    
                ],             
                hasInitializationStage: false,
                contractComplete: false,              
            };
        },    
        mounted() {
            this.loading = true; setTimeout(() => (this.loading = false), 1500);
        },
        created() {
        },    
        methods: {
            selectTemplateModalOpened: function() {
                this.currentSelectedTemplate = null
            },
            selectTemplateOk: function () {
                this.templateLoading = true; setTimeout(() => (this.templateLoading = false), 2000);

                this.resetDesign();
                this.showTemplateContainer = true;
                this.selectedTemplate = this.currentSelectedTemplate;
                console.log("--------------------------------");
                console.log("selected template: " + this.selectedTemplate);

                if(this.selectedTemplate == "ART") {
                    this.template = JSON.parse(JSON.stringify(this.ARTTemplate));
                } else if(this.selectedTemplate == "HSC") {
                    this.template = JSON.parse(JSON.stringify(this.HSCTemplate));
                } else if(this.selectedTemplate == "CAR-T") {
                    this.template = JSON.parse(JSON.stringify(this.CARTTemplate));
                }

            },            
            createNewDesign: function() {
                this.resetDesign();
            },
            resetDesign: function() {
                console.log("designer reset");

                this.hasInitializationStage = false;
                this.contractComplete = false;

                this.showTemplateContainer = false;
                document.getElementById("commit-to-blockchain-button").style.display = 'none';
                document.getElementById("designer-container").style.display = 'none';                

                this.design = {
                    uuid: null,
                    timestamp: null,
                    contractDesignName: "Test Workflow 1",
                    creationDateTime: "",
                    createdBy: "",
                    contractCompleted: false,
                    authorisedEntity: this.$parent.userInfo.username,
                    stages: []
                }

            },   
            createNewContractDesign: function () {
                this.design.uuid = this.createUUID();
                this.design.timestamp = Date.now();
                this.design.stages = [];
                this.design.creationDateTime = new Date();
                this.design.createdBy = this.$parent.userInfo.username;
                this.contractComplete = false;
                document.getElementById("commit-to-blockchain-button").style.display = 'block';
                document.getElementById("designer-container").style.display = 'block';
            },
            loadTestContractDesign: function() {
                this.resetDesign();
                document.getElementById("commit-to-blockchain-button").style.display = 'block';
                document.getElementById("designer-container").style.display = 'block';
                // load test desing
                this.design = this.testDesign;
                // check if "completion" stage exists
                var initializationExists = false;
                var completionExists = false;
                for(var i = 0; i < this.design.stages.length; i++) {
                    if(this.design.stages[i].stageType == "initialization") {
                        initializationExists = true;
                    }   
                    if(this.design.stages[i].stageType == "completion") {
                        completionExists = true;
                    }                    
                }
                if(!initializationExists) {
                    this.hasInitializationStage = false;
                } else {
                    this.hasInitializationStage = true;
                }                
                if(completionExists) {
                    this.contractComplete = true;
                } else {
                    this.contractComplete = false;
                }
            },
            createStage: function(type) {
                console.log("opening modal");
                this.newStage.stageType = null;
                this.disableSelect = false;
                if(this.options[this.options.length -1].value == "subprocess") {
                    this.options.pop();
                }

                // check if first stage
                if(this.design.stages.length == 0) {
                    console.log("FIRST Stage");
                    this.newStage.stageType = "initialization";
                    this.disableSelect = true;
                } else {
                    console.log("NOT First Stage");
                    this.options[1].disabled = true;
                    this.newStage.stageType = "milestone";
                }

                // check if subprocess stage
                if(type == "subprocess") {
                    this.options.push({ value: 'subprocess', text: 'Subprocess Stage' });
                    this.newStage.stageType = "subprocess";
                    this.disableSelect = true;
                } else {
                    this.options[1].disabled = true;
                    //this.newStage.stageType = "milestone";
                    //this.options[3].disabled = true;
                }                
            },   
            addStage: function() {
                console.log("stage added");

                var id = this.design.stages.length;

                // stage object
                var stage = {
                    uuid: this.createUUID(),
                    timestamp: Date.now(),
                    id: null,
                    created: new Date(),
                    stage: null,
                    stageType: null,
                    stageName: null,
                    stageCompleted: false,
                    authorisedEntity: this.$parent.userInfo.username,
                    stageActions: [],
                    subprocesses: []                    
                };

                // subprocess object 
                var subprocess = {
                    uuid: this.createUUID(),
                    timestamp: Date.now(),
                    id: null,
                    created: new Date(),
                    stage: null,
                    stageType: null,
                    stageName: null,
                    stageCompleted: false,
                    authorisedEntity: this.$parent.userInfo.username,
                    stageActions: [],                  
                };                

                if(this.newStage.stageType != "subprocess") {
                    // create new stage
                    stage.id = id +1,
                    stage.stage = (id + 1),
                    stage.stageType = this.newStage.stageType,
                    stage.stageName = this.newStage.stageName,

                    // add new stage to stages
                    this.design.stages.push(stage);   
                } else {
                    // create new subprocess
                    subprocess.id = id + "." + (this.design.stages[this.design.stages.length -1].subprocesses.length +1),
                    subprocess.stage = (id) + "." + (this.design.stages[this.design.stages.length -1].subprocesses.length +1),
                    subprocess.stageType = this.newStage.stageType,
                    subprocess.stageName = this.newStage.stageName,

                    // add new subprocess to the last stage
                    this.design.stages[this.design.stages.length -1].subprocesses.push(subprocess);   
                }

                // check if "initialization" added
                if (this.newStage.stageType == "initialization") {
                    this.hasInitializationStage = true;
                }
                
                // check if "completion" stage selected
                if (this.newStage.stageType == "completion") {
                    this.contractComplete = true;
                }
                
                // clear new stage
                this.newStage.stageType = null;                
                this.newStage.stageName = "New Stage";
                this.disableSelect = false;
            },
            selectedStageForModal: function(stage) {
                this.selectedStage = stage;
            },
            editStage: function() {
                console.log("stage edited");
            },
            deleteStage: function() {
                console.log("delete stage");

                // delete selected stage
                this.design.stages.splice(this.selectedStage.id -1, 1);

                // reindex id's and check for "completion" stage
                var initializationExists = false;
                var completionExists = false;
                for(var i = 0; i < this.design.stages.length; i++) {
                    this.design.stages[i].id = i;
                    if(this.design.stages[i].stageType == "initialization") {
                        initializationExists = true;
                    }                    
                    if(this.design.stages[i].stageType == "completion") {
                        completionExists = true;
                    }
                }

                if(!initializationExists) {
                    this.hasInitializationStage = false;
                }

                if(!completionExists) {
                    this.contractComplete = false;
                }
            },
            createUUID: function() {
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid;                
            },         
            commitToBlockchain: async function() {
                console.log("added contrat desing to the blockchain! 👍");

                // commit contract design template to blockchain
                var contractTemplate = JSON.stringify(this.design);
                
                console.log(contractTemplate);

                // hide table show loading spinner 
                //document.getElementById("blockchain-data-loading").style.display = 'block';
                //document.getElementById("blockchain-table").style.display = 'none';
    
                var blockId = this.$parent.uuidv4();
                
                var timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.design.contractDesignName;

                var data = {
                    "ID": blockId,
                    "TimeStamp": timestamp,
                    "State": "template",
                    "Owner": "Vitrafy",
                    "User": this.$parent.userInfo.username,
                    "TempData": contractTemplate
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8'
                };            

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/CreateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }            
                    

            }                    
        },       
    };
</script>

<style>
    .template-info-table-right {
        padding-left: 30px !important
    }    

    .template-info-table td {
        padding: 3px
    }

    .template-container {
        padding: 40px;
        border: 1px solid;
        margin: 0 auto;   /* centers horizontally */  
        display: flex;
        justify-content: center; /* horizontal */
    }

    .template-milestone-add-container {
        display: flex;
        justify-content: center; /* horizontal */
    }

    .template-milestone-add {
        position: relative;
        border: 1px solid #47d7ac;
        height: 22px;
        width: 22px;
        background-color: white;
    }

    .template-milestone-add-plus {
        position: absolute;
        top: -10px;
        left: 2px;
        font-size: 22px;
    }
    
    .template-milestone-add-line {
        height: 18px;
        width: 50%;
        border-right: 1px solid;
    }

    .template-milestone-add-line-big {
        height: 35px;
    }

    .template-milestone {
        /* border: 1px solid; */
        width: 345px;
        min-height: 100px;
        /* background-color: grey; */
        /* margin-bottom: 100px; */
        position: relative;
    }

    .template-milestone-header img{
        height: 30px;
        border: 1px solid;
        border-radius: 50%;
        margin-right: 10px;
    }

    .template-milestone-header {
        /* border: 1px solid; */
        margin: 0 auto;   /* centers horizontally */  
        font-size: 17px;
        position: relative;
        background-color: #ebebeb;
    }

    .template-milestone-header-actions {
        float: right;
        margin-top: 4px;
        margin-right: 4px;        
    }

    .template-milestone-add-container-up-arrow {
        position: absolute;
        right: 4px;
        top: -25px;        
    }

    .template-milestone-add-up-arrow {
        width: 48px;;
    }

    .template-milestone-add-down-arrow{
        bottom: -25px;
        position: absolute;
        right: 4px;
    }        

    .template-milestone-add-plus-up-arrow {
        left: 15px;
    }

    .template-milestone-content {
        /* border: 1px solid; */
        margin: 0 auto;   /* centers horizontally */  
        display: flex;
        justify-content: center; /* horizontal */
    }

    .template-subprocess-container {
        padding: 22px;
        background-color: #f5f5f5;
        position: relative;
    }

    .template-subprocess {
        width: 300px;     /* or max-width */
        margin: 0 auto;   /* centers horizontally */        
        /* border: 1px solid; */
        width: 216px;
        min-height: 48px;        
        /* background-color: lightgrey; */
        /* margin-top: 25px; */
        /* margin-bottom: 25px; */
    }

    .template-subprocess-left-action-container {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 17px;
        background-color: #c0c0c0;
        height: 100%;
    }

/* Outer row */
.template-subprocess {
  position: relative;
  display: flex;
  align-items: center;              /* vertically centers left icon + content */
  gap: 10px;                        /* space between left icon and text */
  padding: 0px;     /* right padding reserves space for stacked icons */
  min-height: 32px;                 /* optional */
  width: 100%;
  box-sizing: border-box;
  min-height: 48px;
  background-color: white;
}

/* Left icon */
.template-subprocess-left-action {
  display: flex;
  align-items: center;              /* vertical center inside its own box */
  flex: 0 0 auto;                   /* don't stretch */
  z-index: 1;
}

/* Text/content */
.template-subprocess-content {
  flex: 1 1 auto;                   /* take remaining width */
  min-width: 0;                     /* important so flex item can shrink/wrap */
  white-space: normal;              /* allow wrapping */
  overflow-wrap: anywhere;          /* wrap long strings */
  line-height: 1.3;
  margin-right: 30px;
}

/* Right stacked actions pinned top-right */
.template-subprocess-right-action {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;           /* stack on top of each other */
  gap: 4px;
  align-items: center;
    background-color: #f5f5f5;
    height: 100%;
    padding-left: 5px;  
}







    .stage-badge {
        text-transform: uppercase;
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 10px;
        text-align: left;  
    }

    .standard-stage {
        border: 2px solid #0a58ca !important;
        background-color: #c9dfff !important;     
    }

    .subprocess-stage {
        border: 2px solid #495057 !important;
        background-color: #eaeaea !important;
    }

    .initialization-stage {
        background-color: #b8ffb8 !important;
        border: 2px solid green !important;
    }    

    .completion-stage {
        border: 2px solid #dc3545 !important;
        background-color: #ffe9eb !important;    
    }

    .link-line {
        color: #0053a7;
    }

    .add-subprocess {
        float: right !important;
    }

    .design-stage-container {
        width: 100%;
        float: left;
    }

    .stage-menu {
        position: absolute;
        top: 0;
        right: 0;   
    }

    .add-stage {
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    #designer-container {
        display: none;
    }

    .contrat-info-table {
        margin-bottom: 40px;
    }

    .contrat-info-table td {
        vertical-align: top;
    }

    .contract-data {
        padding-left: 10px;
    }

    /* .design-milestone {
        float: none;
    } */

    .design-subprocess {
        float: right !important;
    }

    .design-stage {
        position: relative;
        float: left;
        border: 2px solid;
        min-width: 200px;
        max-width: 200px;
        text-align: center;
        padding: 23px;    
        z-index: 99;
        border-radius: 10px;
    }

    .design-panel {
        /* border: 1px solid; */
        /* width: 50%; */
        float: left;
        padding: 10px;
        max-width: 500px;
        padding-left: 50px;
        /* padding-right: 50px; */
    }

    h6 {
        padding-bottom: 15px;
    }

    /* updated UI */


    .flow-canvas{
  position: relative;
  padding: 24px 0 48px;
  background: radial-gradient(#ececec 1px, transparent 1px);
  background-size: 18px 18px;
  min-height: 400px;
}

.flow-line{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 2px;
  transform: translateX(-50%);
  background: #2f2f2f;
  opacity: .75;
}

.connector{
  position: relative;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.plus-btn{
  width: 38px;
  height: 38px;
  border-radius: 4px;
  border: 2px solid #25c49a;
  background: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.milestone-wrap{ position: relative; z-index: 2; }

.milestone{
  width: 86%;
  max-width: 940px;
  margin: 0 auto;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.milestone-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ededed;
  padding: 12px;
}

.milestone-left{
  display: flex;
  align-items: center;
  gap: 12px;
}

.milestone-icon{
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 2px solid #111;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.milestone-icon-text{
  font-size: 10px;
  opacity: .7;
  text-align: center;
  padding: 0 4px;
}

.milestone-title{
  font-size: 30px;
  font-weight: 500;
}

.milestone-actions{
  display: flex;
  gap: 10px;
}

.milestone-body{
  background: #f3f3f3;
  padding: 18px 0 24px;
  position: relative;
}

.sub-row{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 6px 0;
}

.sub-card{
  width: 58%;
  min-width: 520px;
  max-width: 700px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,.06);
}

.sub-grip{
  width: 42px;
  background: #bfbfbf;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.sub-content{
  padding: 16px 18px;
  display: flex;
  align-items: center;
}

.sub-title{
  font-size: 20px;
  font-weight: 600;
  color: #2b2b2b;
}

.sub-actions{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.icon-btn{
  width: 38px;
  height: 38px;
  border-radius: 4px;
  border: 2px solid #25c49a;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.move-controls{
  position: absolute;
  right: 16px;
  bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.empty-sub{
  padding: 10px 0 0;
}

</style>